import React from "react";
import SimpleDatabasePage from "./SimpleDatabasePage";
import LaborDatabasePage from "./LaborDatabasePage";
import ToolsDatabasePage from "./ToolsDatabasePage";
import MaterialsDatabasePage from "./MaterialsDatabasePage";
import CatalogMappingPage from "./CatalogMappingPage";
import { DATABASE_NAV, SIMPLE_PAGES } from "constants/estimatingDatabasePages";

const DEDICATED = {
  materials: MaterialsDatabasePage,
  labor: LaborDatabasePage,
  tools: ToolsDatabasePage,
  "catalog-mapping": CatalogMappingPage,
};

// One Pricing Catalogs tab per table: { key, title, component }
// (pages/PricingCatelogs/PricingCatalogsWorkspace). Each simple page is keyed
// so a switch between two of them starts from a clean state.
export const DATABASE_TABS = DATABASE_NAV.map((entry) => {
  const Dedicated = DEDICATED[entry.key];
  if (Dedicated) return { key: entry.key, title: entry.title, component: Dedicated };
  if (!SIMPLE_PAGES[entry.key]) return null;
  const Page = () => <SimpleDatabasePage key={entry.key} pageKey={entry.key} />;
  Page.displayName = `DatabasePage(${entry.key})`;
  return { key: entry.key, title: entry.title, component: Page };
}).filter(Boolean);

export {
  SimpleDatabasePage,
  LaborDatabasePage,
  ToolsDatabasePage,
  MaterialsDatabasePage,
  CatalogMappingPage,
};
